import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef, OnDestroy, HostListener } from '@angular/core';
import { Overlay, OverlayRef, OverlayPositionBuilder } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Directive({
  selector: '[appCustomTooltip]'
})
export class CustomTooltipDirective implements OnDestroy {
  @Input('appCustomTooltip') customTooltip: TemplateRef<any>;
  @Input() tooltipCondition: boolean = true; // Additional input for condition (e.g., character length check)
  @Input() tooltipClass: string = '';
  private overlayRef: OverlayRef;
  rigthPositon : any = [
    {
      originX: 'end',
      originY: 'center',
      overlayX: 'start',
      overlayY: 'center'
    }
  ]
  leftPositon : any = [
    {
      originX: 'start',       
      originY: 'center',     
      overlayX: 'end',        
      overlayY: 'center' 
    }
  ]
  constructor(
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder,
    private elementRef: ElementRef,
    private viewContainerRef: ViewContainerRef
  ) {
    
  }

  @HostListener('mouseenter')
  show() {
    const positionStrategy = this.overlayPositionBuilder
      .flexibleConnectedTo(this.elementRef)
      .withPositions(this.tooltipClass.includes('left') ? this.leftPositon : this.rigthPositon);

    this.overlayRef = this.overlay.create({ positionStrategy });
    // Only show tooltip if the condition is met
    if (this.tooltipCondition && this.customTooltip) {
      const tooltipPortal = new TemplatePortal(this.customTooltip, this.viewContainerRef);
      this.overlayRef.attach(tooltipPortal);
      this.overlayRef.overlayElement.classList.add(this.tooltipClass); 
    }
  }

  @HostListener('mouseleave')
  hide() {
    this.overlayRef.detach();
  }

  ngOnDestroy() {
    this.overlayRef?.dispose();
  }

}
